export default __webpack_public_path__ + "static/media/ivyCity-masterImage.a9bf4cfe.png";